import { useUI } from "#src/stores/UI.tsx";
import tw from "#src/utils/tw.ts";
import { useIntersectionObserver } from "#src/utils/useIntersectionObserver.ts";
import { debounce } from "es-toolkit/compat";
import { ReactNode, useEffect, useRef } from "react";

interface Props {
  rows: any[];
  renderRow: (item, index) => any;
  onEndReached?: (rows: any[]) => void;
  className?: string;
  loading?: boolean;
  useWindowScroll?: boolean;
  emptyMessage?: string | ReactNode;
  scrollKey?: string;
  scrollOffset?: number;
  triggerOnNoScroll?: boolean;
  children?: ReactNode;
}

function List(props: Props) {
  const ui = useUI();

  useEffect(() => {
    if (!props.scrollKey) {
      return;
    }

    const list = document.querySelector(`#${props.scrollKey}`);
    const key = ui.scrolls[props.scrollKey];

    if (!list) {
      return;
    }

    if (key && key !== 0) {
      list.scrollTo(0, key);
      ui.setScrolls((current) => ({
        ...current,
        [props.scrollKey]: 0,
      }));
    }

    return () => {
      const list = document.querySelector(`#${props.scrollKey}`);
      if (list) {
        ui.setScrolls((current) => ({
          ...current,
          [props.scrollKey]: list.scrollTop,
        }));
      }
    };
  }, [props.scrollKey]);

  // useEffect(() => {
  //   if (
  //     rows.length === 10 &&
  //     onEndReached &&
  //     !loading
  //   ) {
  //     onEndReached(rows);
  //   }
  // }, [rows]);

  const onBottom = debounce(() => {
    if (props.onEndReached) {
      props.onEndReached(props.rows);
    }
  }, 500);

  const bottomRef = useRef(null);

  useIntersectionObserver({
    target: bottomRef,
    onIntersect: onBottom,
    // enabled: !small && !useWindowScroll,
  });

  const refItem = <div ref={bottomRef} className="h-4" />;

  if (props.rows?.length === 0 && !props.loading) {
    return (
      <div
        className={tw(
          "container-type-size overflow-auto sm:h-full md:pb-14",
          props.className
        )}
      >
        <div className="text-empty p-4">
          <span>
            {typeof props.emptyMessage !== "undefined"
              ? props.emptyMessage
              : "No items to display."}
          </span>
        </div>
        {refItem}
      </div>
    );
  }

  return (
    <div
      id={props.scrollKey || "scrolls"}
      className={tw(
        "container-type-size pb-8",
        !props.useWindowScroll && "h-full overflow-auto",
        props.className
      )}
    >
      {props.children}
      {props.rows?.map((r, i) => props.renderRow(r, i))}
      {refItem}
    </div>
  );
}

export default List;
